import React, { useState, useCallback } from 'react';

import { MultiViewPaywall, ViewNames } from './MultiViewPaywall';
import { FreeArticlePaywall } from './paywallContent';

export const ArticlePaywall: React.FC = () => {
  const [isClosable, setIsClosable] = useState(true);

  const onViewChanged = useCallback((viewKey: ViewNames) => {
    setIsClosable(viewKey !== 'Anon');
  }, []);

  return (
    <MultiViewPaywall
      initialView="Anon"
      onClose={({ setView }) => setView('Anon')}
      closable={isClosable}
      onViewChanged={onViewChanged}
      views={{
        Anon: setView => <FreeArticlePaywall onClickSignIn={() => setView('SignIn')} />,
      }}
    />
  );
};
